export interface IOrganizationUnitDocument {
  id: string;
  name: string;
  description: string;
  relativePath: string;
  absolutePath: string;
  uploadedByTechnicalOffice: boolean;
  hasBeenDownloadedByOrganization: boolean;
  createdAt: string;
  updatedAt: string | null;
}

export class OrganizationUnitDocument implements IOrganizationUnitDocument {
  id: string;
  name: string;
  description: string;
  relativePath: string;
  absolutePath: string;
  uploadedByTechnicalOffice: boolean;
  hasBeenDownloadedByOrganization: boolean;
  createdAt: string;
  updatedAt: string | null;

  get isNew(): boolean {
    return !this.hasBeenDownloadedByOrganization;
  }

  get createdAtDate(): Date {
    return new Date(this.createdAt);
  }

  get updatedAtDate(): Date | null {
    return this.updatedAt ? new Date(this.updatedAt) : null;
  }

  get displayDate(): Date {
    return this.updatedAtDate ?? this.createdAtDate;
  }

  constructor(data: IOrganizationUnitDocument) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.relativePath = data.relativePath;
    this.absolutePath = data.absolutePath;
    this.uploadedByTechnicalOffice = data.uploadedByTechnicalOffice;
    this.hasBeenDownloadedByOrganization = data.hasBeenDownloadedByOrganization;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}
